export const getOptionLabel = (employee) =>{
    const {name, surname} = employee
    employee.label = `${surname} ${name}`
}